import { validateEmail as validateEmailTvpil } from '@kaltura-ott/tvpil';

export const validateEmail = (field: string, value: string) => {
  const isValid = field === 'email' ? validateEmailTvpil(value) : value !== '';
  return isValid;
};
